/**
 * Patient Bridge Program — field-level effects (mirrors patient_pap deny alternatives).
 */
import { buildApiUrl, fetchAPI } from "@neu/libui";
import type { FieldHandler } from "@neu/libui";

export const BridgeStatusChange: FieldHandler = (field, props) => {
	void (async () => {
		const { form, ...rest } = props;

		const status = form.getFieldState("status")?.value;
		if (status !== "Denied") return;

		const medId =
			rest.parentForm?.getFieldState("medication_id")?.value?.id;

		if (!medId) return;

		try {
			const invData = await fetchAPI(buildApiUrl(`/inventory/${medId}`));
			const inv = Array.isArray(invData) ? invData[0] : invData;
			if (!inv.brand_name_id?.id) return;

			const brandData = await fetchAPI(
				buildApiUrl(`/drug_brand_short/${inv.brand_name_id?.id}`)
			);
			const brand = Array.isArray(brandData) ? brandData[0] : brandData;
			if (!brand) return;

			form.setFieldState("is_copay_available", (s) => {
				s.value = brand.copay_available || "No";
			});
			form.setFieldState("is_340b_available", (s) => {
				s.value = brand.discount_drug_program_available || "No";
			});

			if (Array.isArray(brand.drug_copay) && brand.drug_copay.length) {
				const copayOptions = brand.drug_copay.map((record: any) => ({
					value: record.id,
					label: record.name,
				}));
				form.setFieldState("copay_program", (s) => {
					s.dataSource = copayOptions;
				});
			}
		} catch (err) {
			console.error("BridgeStatusChange: API error", err);
		}
	})();
	return "";
};

export const BridgeCheckCondition: FieldHandler = (field, { form }) => {
	const startCopayApp = form.getFieldState("start_copay_app")?.value;
	const is340bAvailable = form.getFieldState("is_340b_available")?.value;

	form.setFieldState("condition_chck", (s) => {
		s.value = "No";
	});

	if (is340bAvailable === "Yes" && startCopayApp !== "Yes") {
		form.setFieldState("condition_chck", (s) => {
			s.value = "Yes";
		});
	}
	return "";
};

export const BridgeCheckForAlert: FieldHandler = (field, { form }) => {
	form.setFieldState("show_alert", (s) => {
		s.value = "No";
	});

	const startCopayApp = form.getFieldState("start_copay_app")?.value;
	const start340bApp = form.getFieldState("start_340b_app")?.value;
	const isCopayAvailable = form.getFieldState("is_copay_available")?.value;
	const is340bAvailable = form.getFieldState("is_340b_available")?.value;

	if (startCopayApp === "Yes") {
		form.setFieldState("show_alert", (s) => {
			s.value = "Yes";
		});
		form.setFieldState("alert", (s) => {
			s.value = "Copay added to the case";
		});
	}

	if (start340bApp === "Yes") {
		form.setFieldState("show_alert", (s) => {
			s.value = "Yes";
		});
		form.setFieldState("alert", (s) => {
			s.value = "340B/discount drug program will added to the case";
		});
	}

	if (isCopayAvailable === "No" && is340bAvailable === "No") {
		form.setFieldState("show_alert", (s) => {
			s.value = "Yes";
		});
		form.setFieldState("alert", (s) => {
			s.value =
				"Drug has no copay or 340B options available, you will need to communicate with the member regarding other options";
		});
	}

	return "";
};
